import React, { ReactNode } from "react";
import Icon from "../../theme/icon/Icon";
import Text from "../../theme/text/Text";
import Styles from "./WorkflowHeader.module.scss";

export default function WorkflowHeader({
    title,
    controls,
}: {
    title?: string;
    controls?: ReactNode
}) {
    return (
        <div className={Styles.header}>
            <div className={Styles.title}>
                <Icon.Automation background="warning" size="large" variant="warning" isRounded className={Styles.icon} />
                <Text
                    as="h5"
                    textVariant="subtitle-2"
                    colorVariant="text-title"
                    className={Styles["overflow-ellipsis"]}
                >
                    {title ?? "Automation"}
                </Text>
            </div>
            {controls}
        </div>
    );
}

WorkflowHeader.defaultProps = {
    title: undefined,
    controls: undefined,
};
